import { render, staticRenderFns } from "./AdvancedColourMatchV2Modal.vue?vue&type=template&id=76a8f58a&"
import script from "./AdvancedColourMatchV2Modal.vue?vue&type=script&lang=js&"
export * from "./AdvancedColourMatchV2Modal.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedColourMatchV2Modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports